// extracted by mini-css-extract-plugin
export default {"wrapper":"FilteredCard_wrapper__DDwk5","link":"FilteredCard_link__NZ5X0"};